import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { PayrollCalendarsResponse } from '../payrollCalendar.types';

export const QUERY_KEY = 'useGetPayrollCalendarsQuery';

export const useGetPayrollCalendarsQuery = (orgId?: string) => {
  const { isLoading, error, data, isSuccess, isError, refetch } = useQuery(
    [QUERY_KEY, orgId],
    () => api.get(API_URL.UI_PAYROLL_CALENDARS_ORGANIZATIONS_BY_ORGANIZATION_ID(orgId || '')),
    {
      enabled: !!orgId,
    }
  );

  const total = useMemo(() => data?.data?.length || 0, [data]);
  const updatedData = useMemo(() => data?.data as unknown as PayrollCalendarsResponse[], [data]);
  return {
    data: updatedData,
    total,
    error,
    isError,
    isLoading,
    isSuccess,
    refetch,
  };
};
